import { render, staticRenderFns } from "./LiveRecord.vue?vue&type=template&id=0345c638&scoped=true"
import script from "./LiveRecord.vue?vue&type=script&lang=js"
export * from "./LiveRecord.vue?vue&type=script&lang=js"
import style0 from "./LiveRecord.vue?vue&type=style&index=0&id=0345c638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345c638",
  null
  
)

export default component.exports